export default {"src":"/_next/static/media/0x07f0a80ad7aeb7bfb7f139ea71b3c8f7e17156b9.2b15ea97.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};